import { Component, Injector, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { ToastrService } from 'ngx-toastr';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { StructureSelectorComponent } from 'src/app/shared/modals/StructureSelector/structureselector.component';

@Component({
    selector: 'app-editparkchirpconfig',
    templateUrl: './editparkchirpconfig.component.html',
    styleUrls: ['./editparkchirpconfig.component.scss'],
    standalone: false
})
export class EditParkChirpConfigComponent extends ModelEditor implements OnInit {
  public modalService: SimpleModalService;
  public StandardParkingPermitTypes: any[] = [];
  public ReservationParkingPermitTypes: any[] = [];
  public ParkingLots: any[] = [];

  // NEW: workflow state options
  public StandardWorkflowStates: any[] = [];
  public ReservationWorkflowStates: any[] = [];

  constructor(
    private apiService: ApiServiceBase, 
    private injector: Injector, 
    modalService: SimpleModalService,
    private toastr: ToastrService
  ) {
    super("integrations/parkchirp/configurations", injector);
    this.modalService = modalService;
    this.parentRoute.params.subscribe(params => { this.ModelId = params['id']; });
  }

  public override BeforeSave(): void {
    return;
  }


  public override DefaultModel(): any {
    return {
      Name: "",
      Description: "",
      Url: "https://api.parkchirp.com/",
      Username: "",
      Password: "",
      // CHANGED: now IDs (numbers), leave null until user selects
      StandardInitialPermitState: null,
      ReservationInitialPermitState: null,
      StandardParkingPermitTypeId: "",
      ReservationParkingPermitTypeId: "",
      ParkingLotMapItems: []
    }
  }

  public override Validators(): any {
    return {
      Url: [Validators.maxLength(100), Validators.minLength(1), Validators.required],
      Name: [Validators.maxLength(40), Validators.minLength(1), Validators.required],
      Username: [Validators.maxLength(40), Validators.required],
      Password: [Validators.maxLength(40)],
      Description: [Validators.maxLength(200)],
      // CHANGED: require selection (numeric id)
      StandardInitialPermitState: [Validators.required],
      ReservationInitialPermitState: [Validators.required],
      StandardParkingPermitTypeId: [Validators.required],
      ReservationParkingPermitTypeId: [Validators.required]
    }
  }

  public override AfterModelLoaded(): void {
    this.LoadStandardParkingPermitTypes();
    this.LoadReservationParkingPermitTypes();

    // Subscribe to permit type changes to refresh state lists
    this.Form.get('StandardParkingPermitTypeId')?.valueChanges.subscribe((id) => {
      this.RefreshStandardWorkflowStates(id);
    });
    this.Form.get('ReservationParkingPermitTypeId')?.valueChanges.subscribe((id) => {
      this.RefreshReservationWorkflowStates(id);
    });

    // Initial refresh if editing existing model
    const stdId = this.Form.get('StandardParkingPermitTypeId')?.value;
    if (stdId) this.RefreshStandardWorkflowStates(stdId);
    const resId = this.Form.get('ReservationParkingPermitTypeId')?.value;
    if (resId) this.RefreshReservationWorkflowStates(resId);
  }

  private LoadStandardParkingPermitTypes(): void {
    this.apiService.Get<any>("permits/standardpermittypes").then(result => {
      this.StandardParkingPermitTypes = result;
    });
  }

  private LoadReservationParkingPermitTypes(): void {
    this.apiService.Get<any>("permits/reservationpermittypes").then(result => {
      this.ReservationParkingPermitTypes = result;
    });
  }

  // NEW: helpers to get workflow states by permit type id
  private async RefreshStandardWorkflowStates(permitTypeId: any) {
    this.StandardWorkflowStates = [];
    this.Form.get('StandardInitialPermitState')?.setValue(null, { emitEvent: false });
    if (!permitTypeId) return;
    const className = await this.ResolvePermitTypeClass('standard', permitTypeId);
    await this.LoadWorkflowStates(className).then(states => {
      this.StandardWorkflowStates = states;
      // keep existing selection if still valid
      const current = this.Form.get('StandardInitialPermitState')?.value;
      if (current && !this.StandardWorkflowStates.find(s => s.Id === current)) {
        this.Form.get('StandardInitialPermitState')?.setValue(null);
      }
    });
  }

  private async RefreshReservationWorkflowStates(permitTypeId: any) {
    this.ReservationWorkflowStates = [];
    this.Form.get('ReservationInitialPermitState')?.setValue(null, { emitEvent: false });
    if (!permitTypeId) return;
    const className = await this.ResolvePermitTypeClass('reservation', permitTypeId);
    await this.LoadWorkflowStates(className).then(states => {
      this.ReservationWorkflowStates = states;
      const current = this.Form.get('ReservationInitialPermitState')?.value;
      if (current && !this.ReservationWorkflowStates.find(s => s.Id === current)) {
        this.Form.get('ReservationInitialPermitState')?.setValue(null);
      }
    });
  }

  // Resolve targetType = class of the permit type
  private async ResolvePermitTypeClass(kind: 'standard' | 'reservation', id: any): Promise<string> {
    try {
      const path = kind === 'standard' ? `permits/standardpermittypes/${id}` : `permits/reservationpermittypes/${id}`;
      const type = await this.apiService.Get<any>(path);
      // Expecting a ClassName; fall back to 'ParkingPermit' if not present
      return type?.ClassName || 'ParkingPermit';
    } catch {
      return 'ParkingPermit';
    }
  }

  private async LoadWorkflowStates(targetType: string): Promise<any[]> {
    const wf = await this.apiService.Get<any>(`workflow/default/${encodeURIComponent(targetType)}`);
    return wf?.States || [];
  }


  

  
}
